import { motion } from "framer-motion";
import { useI18n } from "@/lib/i18n";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1629140727571-9b5c6f6267b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBob3RlbCUyMGJlZHJvb20lMjBpbnRlcmlvcnxlbnwwfHx8fDE3Nzg0MjY3NTV8MA&ixlib=rb-4.1.0&q=85";

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] } },
};

export default function About() {
  const { t } = useI18n();
  return (
    <section
      id="about"
      className="relative bg-sand-50 py-24 md:py-32 lg:py-40 overflow-hidden"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-100px" }}
          className="lg:col-span-7 flex flex-col"
        >
          <span className="text-[10px] md:text-[11px] tracking-[0.4em] uppercase text-gold-dark mb-7">
            — {t.about.kicker}
          </span>
          <h2
            className="font-serif font-light leading-[1.08] tracking-[-0.01em] text-4xl md:text-5xl lg:text-[58px] text-ink-900 mb-10 max-w-[520px]"
            data-testid="about-title"
          >
            {t.about.title}
          </h2>
          <p className="text-[15px] md:text-base text-ink-700 leading-[1.85] mb-5 max-w-[480px]">
            {t.about.p1}
          </p>
          <p className="text-[15px] md:text-base text-ink-700 leading-[1.85] max-w-[480px] italic font-serif">
            {t.about.p2}
          </p>

          <div className="mt-14 flex items-center gap-4">
            <span className="block w-12 h-px bg-gold" />
            <span className="text-[10px] tracking-[0.4em] uppercase text-gold-dark">Ibiza</span>
            <span className="block w-12 h-px bg-gold" />
          </div>
        </motion.div>

        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-100px" }}
          className="lg:col-span-5"
        >
          <div className="relative aspect-[3/4] w-full overflow-hidden">
            <img
              src={ABOUT_IMG}
              alt="Luxury interior with perfectly made bed and warm light"
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-[2000ms] ease-out"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink-900/30 via-transparent to-transparent" />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
